import React from "react"
import Block from "@bappweb/block"
import MainForm from "./form"
import Element from "@bappweb/element"

const Landing = () => {
    return (
        <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
            <Element type="h2" className="landing-text h2-text">Akbank Bilgi Formu</Element>
            <Element type="p" className="landing-text p-text">Başvuru formunu açmak için lütfen aşağıdaki bilgileri doldurunuz.</Element>
            <MainForm />
        </Block>
    )
}

export default Landing
